module.exports = __webpack_public_path__ + "img/Be_A_Cyber Smart-y.99e0bca2.jpg";